const Form003EN = {
    stepName: {
        statement: "Important Notes",
        applicationForm: "Application Form",
        schoolInformation: "School Information",
        confirmation: "Confirmation",
        choosePlan: "Selection of Part A/Part B",
        partA: "Part A",
        partB: "Part B",
    },
    label: {
        statement:
            "I have read, understand and agree to the above terms and conditions.",
        iamSmartCondition:
            "I understand this e-Form can only be signed with “iAM Smart+” by the School Supervisor.",
        choosePlan: {
            formVersion:
                "Please select the appropriate version of the application form",
            title1: "My school will /will not",
            title2: " participate in the programme of Free Lunch at Schools (“the Programme”).",
            planA: "will",
            planB: "will not",
            selectionOptions: {
                will: "will",
                willNot: "will not",
            },
        },
        partA: {
            errorMsg: {
                maxError: "Maximum length is ",
                error1: "If you chose Others. Please write down specification",
                error2: "Character type (alphabets only / alpha-numeric / Chinese-only)",
                notTheSame:
                    "(i) and (ii) should not be checked at the same time",
                errPriceMsg: "target student",
                schoolCode: "This field must be {{length}} digits",
                titleCorrespondLang:
                    "Chinese and English title must correspond to each other",
            },

            title1: "(1) My school will adopt the following mode of arranging lunch for students at school:",
            node: {
                node: "Note",
                note1Normal:
                    "My school will properly inform parents of the programme of Free Lunch at Schools, in particular the requirements for provision of free lunch at schools for eligible primary students as set out in the Education Bureau Circular Memorandum No. {{circularNumber}}. Details are as follows:",
                node1: "My school will duly inform parents of the details of the Programme and provide eligible students with free lunch at schools. The details of the lunch arrangement of my school are as follows:",
                node2: "(Please put a “√” in the appropriate box and fill in the required information.) ",
            },

            mode: {
                mode1: `(i) Selecting the lunch supplier through the existing tendering and procurement procedures.`,
                mode2: "(ii) Hiring staff to provide lunch for students.",
                mode3: "(iii) Others",
            },
            modePlaceHolder: "please specify",
            modeName: "mode",
            title2: ` <span style="text-decoration:underline"></span>`,
            firstUnderlineTitle2: "different",
            beforeFirstUnderlineTitle2:
                "(2) The price for each student lunch in the {{schoolYear}} school year is as follows (",
            afterFirstUnderlineTitle2Normal:
                "if the lunch prices for different groups of students, such as junior/senior primary students, are different, please enter the respective prices; if there is only ",
            afterFirstUnderlineTitle2:
                "<i>if the lunch prices for different groups of students, such as junior/senior primary students, are different, please enter the respective prices; if there is only <u>one</u> lunch price, please fill in Price 1.</i>",
            secondUnderlineTitle2: "one",
            afterSecondUnderlineTitle2: "):",
            afterSecondUnderlineTitle2Normal:
                " lunch price, please fill in Price 1.):",
            // content1: "Is there only one price",
            content2Normal:
                "(Please enter the price stated in the contract with the lunch supplier or the price that parents are informed of under other modes of lunch arrangement.)",
            content2: `(Please indicate the price stated in the contract with the lunch supplier or the price that parents are informed of under other modes of lunch arrangement.)`,
            price1: "Price 1 target students",
            price2: "Price 2 target students",
            // price3: "Price 3 (for days with half-day schooling)",
            HKD: "HKD",
            title3: `(3) The estimated number of days with provision of free lunch at schools for students (<i>the number of days with school lunch arrangements may be different from the number of school days</i>):`,
            content3: "(i) {{startOfDaysLabel}} ({{endOfDaysLabel}}):",
            day1: " days",
            content4: "(ii) {{startOfSecDaysLabel}} {{endOfSecDaysLabel}}:",
            day2: " days",
            dayMsg: "number",
            tooltip1:
                "Only applicable to circumstances when half-day schooling is implemented as announced by the Education Bureau.",
            tooltip2:
                "For participating schools, please complete Part A of the Application Form; for non-participating schools,please complete Part B.",
        },
        partB: {
            title: "My school will NOT participate in the Programme. The reason is as follows:",
            mainCause: "The reason",
            errMsg: "reason",
        },
        certification: "Name of Teaching Staff-in-charge",
        telNo: "School Telephone No.",
        fax: "Fax No.",
        date: "Date",
        deadline: "Deadline",
        circularNumber: "Circular Number",
        supervisorName: "Name of Supervisor",
        title: "Title",
        supervisorNameCN: "Name of Supervisor",
        titleCN: "Title (Chinese)",
        supervisorNameEN: "Name of Supervisor",
        titleEN: "Title (English)",
        schoolName: "Name of School",
        schoolCode: "School Code",
        versionOptions: {
            normal: "regular version",
            special: "Epidemic Special Edition",
        },
        email: "School Email Address",
        titleCNOptions: [
            "先生",
            "女士",
            "小姐",
            "太太",
            "博士",
            "教授",
            "牧師",
            "神父",
            "修女",
            "法師",
            "修士",
        ],
        titleENOptions: [
            "Mr",
            "Ms",
            "Miss",
            "Mrs",
            "Dr",
            "Prof",
            "Rev",
            "Fr",
            "Sr",
            "Ven",
            "Br",
        ],
        supervisorNameErrorMsg:
            "Name of Supervisor (Chinese) and Name of Supervisor (English) must be corresponded",
    },
    params: {
        schoolYear: "2021/22",
        circularNumber: "64/2021",
        endOfDaysLabelEn: "to March 2021 for government primary schools",
        endOfSecDaysLabelEn:
            "(from April 2021 for government primary schools) to July 2021",
        startOfDaysLabelEn: "from September 2021 to December 2021",
        startOfSecDaysLabelEn: "from January 2022",
    },
    note: {
        note1: `Regarding the application for "Free Lunch at Schools" of this school year, my school has acknowledged the relevant details, and will duly inform parents of the arrangement concerned.`,
    },
};
export default Form003EN;
